import React, {
  FC,
  useState,
  useRef,
  useEffect,
  CSSProperties,
  useImperativeHandle,
  forwardRef,
} from 'react';
// import PitButtonGroup from './components/PitButtonGroup';
// import PitBimwinBtn from './components/PitBimwinBtn';
import PitToolTip from './components/PitToolTip/PitToolTip';
import PitBimwinDialog from './components/PitBimwinDialog/PitBimwinDialog';
import PitModuleTree from './components/PitBusiness/PitBimwinTree';
import PitModuleMeasure from './components/PitBusiness/PitMeasure';
import PitModuleSectioning from './components/PitBusiness/PitSection';
import PitModuleSectionAxis from './components/PitBusiness/PitSectionAxis';
// import PitModuleShortcut from './components/PitBusiness/PitShortcut';
import PitModuleProperties from './components/PitBusiness/PitComponentDetails';
import PitModuleLabelBox from './components/PitBusiness/PitLabelBox';
import PitModuleInformation from './components/PitBusiness/PitInformation';
import PitModuleSetUp from './components/PitBusiness/PitSetUp';
import PitToolbarMenu from './components/PitBusiness/PitToolbarMenu';
import PitRoam from './components/PitBusiness/PitRoam';
import PitMenuRight from './components/PitBusiness/PitMenuRight';
import loadingImg from './assets/images/loading/loading.png';
import styles from './styles/app.module.scss';
import { useBtnOption, BtnProps } from './useBtnOpt';
import { dataGroupingToDeepArray } from './utils';
import { useBimwinState, useMenuState } from './hooks';
import {
  createBimWin,
  setBackgroundColor,
  optionsType,
  outlineNodeSetEnable,
  setSelectMode,
} from './core/createBimWin';
import { BIM_TYPE } from './utils/define';

import { ISecret, BIMWin2D, Platform } from 'bimwin-api';

export type clickProps =
  | 'FLODER_TREE'
  | 'MEASURE'
  | 'SECTIONING'
  | 'SECTIONAXIS'
  | 'ROAM'
  | 'PROPERTIES'
  | 'LABELBOX'
  | 'INFORMATION'
  | 'SETUP'
  | 'COMMENTS'
  | 'HOME_VIEW'
  | 'SET_CURRENT'
  | 'REST_CURRENT'
  | 'FULL_SCREEN';
// console.log(styles)
interface PitBimwinAppProps {
  options: optionsType;
  headers: ISecret;
  visibleToolbar?: string[];
  style?: CSSProperties;
  ref?: any;
}
// let structureData: any = {};
// 主体：
const PitBimwinApp: FC<PitBimwinAppProps> = forwardRef(
  ({ options, headers, visibleToolbar, children }, parentRef) => {
    let {
      bimwinData,
      setBimwinData,
      properties,
      structureData,
      // setstructureData,
      requestAnimationFrame,
      handleClickMainPerspective,
      handleClickCurrentMainPerspective,
      handleClickResetMainPerspective,
      handleClickFullScreen,
      setproperties,
    } = useBimwinState('3D');
    const pitMenuRight = useRef(null);
    // 抛出platform实例
    useImperativeHandle(parentRef, () => bimwinData.platform);
    const { menuState, setMenuState } = useMenuState();
    let [isShowRootMenu, setisShowRootMenu] = useState(true);
    let [isShowFirstPersonMenu, setisShowFirstPersonMenu] = useState(false);
    const [isModelLoading, setisModelLoading] = useState(false);
    let [annotation, setannotation] = useState({
      dialog: false,
      widthAndHeight: {},
      isShow: false,
      isDisabled: false,
      isLineAndFontSHow: true,
      colorBoxIsShow: false,
      lineBoxIsShow: false,
      fontBoxIsShow: false,
      colorCurrent: 'red',
      colorIndex: 0,
      isShowAnnotationMenu: false,
      colorArr: [
        {
          name: '红',
          color: '#d0021b',
          type: 'red',
        },
        {
          name: '黄',
          color: '#f5a623',
          type: 'yellow',
        },
        {
          name: '蓝',
          color: '#4a90e2',
          type: 'blue',
        },
        {
          name: '绿',
          color: '#7ed321',
          type: 'green',
        },
      ],
      lineCurrent: 'fine',
      lineIndex: 0,
      lineArr: [
        {
          name: '细',
          height: '4px',
          margin: '14.5px 4px',
          type: 'fine',
        },
        {
          name: '中',
          height: '7px',
          margin: '13px 4px',
          type: 'in',
        },
        {
          name: '粗',
          height: '11px',
          margin: '11px 4px',
          type: 'crude',
        },
      ],
      itemCurrent: 'Arrow',
      itemArr: [
        {
          type: 'Arrow',
          name: '箭头',
          icon: 'pit-xingzhuang-jianxing',
        },
        {
          type: 'Ncloud',
          name: '云线框',
          icon: 'pit-gateway',
        },
        {
          type: 'FreeDraw',
          name: '自由绘制',
          icon: 'pit-icon-test4',
        },
        {
          type: 'Line',
          name: '折线',
          icon: 'pit-icon-line-graph',
        },
        {
          type: 'Rect',
          name: '矩形',
          icon: 'pit-xingzhuang-juxing',
        },
        {
          type: 'Noval',
          name: '椭圆',
          icon: 'pit-tuoyuan',
        },
        {
          type: 'Mark',
          name: 'X',
          icon: 'pit-cross',
        },
        {
          type: 'Ntext',
          name: '文字',
          icon: 'pit-font-size',
        },
      ],
      fontCurrent: 'small',
      fontIndex: 0,
      fontArr: [
        {
          name: '14',
          type: 'small',
        },
        {
          name: '18',
          type: 'in',
        },
        {
          name: '24',
          type: 'large',
        },
      ],
      value: '',
      img: '',
    });
    const btnOption = useBtnOption();
    const [toolbarMenuList, setToolbarMenuList] = useState<BtnProps[][]>();

    const pitWebglContainer = useRef<any>('');
    const pitBimWinContainer = useRef(null);
    const roamClose = () => {
      setisShowRootMenu(() => true);
      setisShowFirstPersonMenu(() => false);
    };

    /**
     * 属性加载完成
     * @param {Platform}
     */
    const onPropertyLoaded = (platform: Platform, bimType: string) => {
      platform.BwEvent.OnPropertyLoaded.add(props => {
        console.log('加载构建', props);
        if (props != undefined) {
          // 获取构建JSON并重新序列化
          if (structureData.Tree == undefined && props.Tree != undefined) {
            structureData = props;
          } else {
            if (props.Props != undefined) {
              if (bimType == BIM_TYPE.THREE_DIMENSIONAL) {
                structureData.Props.push(...props.Props);
              } else {
                structureData.Props = Object.freeze(props.Props);
              }
            }
          }
        }
      });
    };
    /**
     * 鼠标点击回调
     * @param {Platform}
     */
    const onPickPoint = (platform: Platform, pitMenuRight: any) => {
      // 鼠标点击回调
      platform.bimwin.onPickPoint.add(async ev => {
        // 判断是左键或者右键
        let list = await platform.bimwin.getNodeHighlightSet();
        if (ev == null) {
          // 右键点击
          if (list.size > 0) {
            list.forEach(element => {
              wiGldBfProperties(element, pitMenuRight);
            });
          } else {
            wiGldBfProperties('', pitMenuRight);
          }
        } else {
          if (ev.hit) {
            if (list.size == 0) {
              wiGldBfProperties('', pitMenuRight);
              setproperties((pre: any) => {
                pre.value = [];
                return { ...pre };
              });
              return;
            }
            list.forEach(element => {
              wiGldBfProperties(element, pitMenuRight);
            });
          } else {
            list.forEach(element => {
              platform.bimwin.setNodesState([element], 1);
            });
            setproperties((pre: any) => {
              pre.value = [];
              return { ...pre };
            });
            wiGldBfProperties('', pitMenuRight);
          }
        }
      });
    };
    /** wi构件详情传值 */
    const wiGldBfProperties = (value: string, pitMenuRight: any) => {
      pitMenuRight.menuDataListFn(value);
      console.log(structureData, 'structureData');
      // 查找对应的构建数据
      if (
        value != '' &&
        structureData != null &&
        structureData.Props != null &&
        structureData.Props.length > 0
      ) {
        for (const iterator of structureData.Props) {
          if (iterator.Id == value) {
            setproperties((pre: any) => {
              pre.value = iterator.Groups;
              return { ...pre };
            });
            // Revit属性
            let p: any = properties.value;
            let typeId = undefined;
            for (let i = 0, len = p.length; i < len; i++) {
              if (p[i].Props['类型ID'] !== undefined) {
                typeId = p[i].Props['类型ID'];
                break;
              }
            }
            if (
              structureData.Revit !== undefined &&
              typeId !== undefined &&
              structureData.Revit.FamilyTypeProps != undefined
            ) {
              let familyTypeProps = structureData.Revit.FamilyTypeProps;

              let a: any = properties.value;
              let b = familyTypeProps[typeId].Groups;
              b.forEach((group: any) => {
                let hasProp = -1;
                for (let i = 0, len = a.length; i < len; i++) {
                  if (group.Name === a[i].Name) {
                    hasProp = i;
                    break;
                  }
                }
                if (hasProp !== -1) {
                  let keys = Object.keys(group.Props);
                  keys.forEach(key => {
                    a[hasProp].Props[key] = group[key];
                  });
                } else {
                  a.push(group);
                }
              });
              setproperties((pre: any) => {
                pre.value = a;
                return { ...pre };
              });
            }
            break;
          }
        }
      }

      // Pdms属性
      if (properties.value.Id !== value && structureData.Pdms !== undefined) {
        if (structureData.Pdms.TreeProps[value] !== undefined) {
          setproperties((pre: any) => {
            pre.value = structureData.Pdms.TreeProps[value].Groups;
            return { ...pre };
          });
        }
      }
    };
    /** wi构件详情按钮事件 */
    const wiGldBfPropertiesOpen = () => {
      setMenuState({ componentDetails: true });
    };
    const btnClickCallBack = (
      itemData: BtnProps,
      index: number,
      type?: clickProps
    ) => {
      console.log(type);
      switch (type) {
        case 'HOME_VIEW':
          handleClickMainPerspective();
          break;
        case 'SET_CURRENT':
          handleClickCurrentMainPerspective();
          break;
        case 'REST_CURRENT':
          handleClickResetMainPerspective();
          break;
        case 'FLODER_TREE':
          setMenuState({ directoryTree: true });
          break;
        case 'FULL_SCREEN':
          handleClickFullScreen(
            itemData,
            pitBimWinContainer,
            setToolbarMenuList,
            index
          );
          break;
        case 'MEASURE':
          setMenuState({ measurement: true });
          break;
        case 'SECTIONING':
          setMenuState({ section: true });
          break;
        case 'SECTIONAXIS':
          setMenuState({ axialSection: true });
          break;
        case 'ROAM':
          setisShowRootMenu(() => false);
          setisShowFirstPersonMenu(() => true);
          break;
        case 'PROPERTIES': // 构件详情
          setMenuState({ componentDetails: true });
          break;
        case 'LABELBOX': // 标签
          setMenuState({ label: true });
          break;
        case 'INFORMATION': // 基本信息
          setMenuState({ basicInformation: true });
          break;
        case 'SETUP': // 设置
          setMenuState({ setUp: true });
          break;
        case 'COMMENTS':
          setisShowRootMenu(false);
          setannotation(pre => {
            pre.isShowAnnotationMenu = !pre.isShowAnnotationMenu;
            return { ...pre };
          });
      }
    };
    const beforeClose = (typeVisible: string) => {
      switch (typeVisible) {
        case 'visible': // 目录树
          setMenuState({ directoryTree: false });
          break;
        case 'measureVisible': // 测量
          setMenuState({ measurement: false });
          break;
        case 'pouQieVisible': // 剖切
          setMenuState({ section: false });
          break;
        case 'rowPouQieVisible':
          setMenuState({ axialSection: false });
          break;
        case 'properties': // 构件详情
          setMenuState({ componentDetails: false });
          break;
        case 'label':
          setMenuState({ label: false });
          break;
        case 'basicInformation':
          setMenuState({ basicInformation: false });
          break;
        case 'setUp':
          setMenuState({ setUp: false });
          break;
      }
    };
    const annotationToggle = (type: string) => {
      switch (type) {
        case 'color':
          setannotation(pre => {
            pre.colorBoxIsShow = !pre.colorBoxIsShow;
            pre.lineBoxIsShow = false;
            pre.fontBoxIsShow = false;
            return { ...pre };
          });
          break;
        case 'line':
          setannotation(pre => {
            pre.lineBoxIsShow = !pre.lineBoxIsShow;
            pre.colorBoxIsShow = false;
            pre.fontBoxIsShow = false;
            return { ...pre };
          });
          break;
        case 'font':
          setannotation(pre => {
            pre.fontBoxIsShow = !pre.fontBoxIsShow;
            pre.colorBoxIsShow = false;
            pre.lineBoxIsShow = false;
            return { ...pre };
          });
          break;
      }
    };
    const annotationCancelBtn = () => {
      setisShowRootMenu(true);
      setannotation(pre => {
        pre.isShowAnnotationMenu = false;
        pre.colorBoxIsShow = false;
        pre.lineBoxIsShow = false;
        pre.fontBoxIsShow = false;
        return { ...pre };
      });
    };
    const initToolbar = () => {
      let result = btnOption.value;
      if (visibleToolbar && visibleToolbar.length > 0) {
        result = result.filter(
          (item: BtnProps) => !visibleToolbar.includes(item.id)
        );
      }
      // 三维模式下显示的图标ids
      if (bimwinData.bimType === BIM_TYPE.THREE_DIMENSIONAL) {
        const threeDimensionalIds = ['layer', 'minimap'];
        result = result.filter(
          (item: BtnProps) => !threeDimensionalIds.includes(item.id)
        );
      }
      // 二维模式下显示的图标ids
      if (bimwinData.bimType === BIM_TYPE.TWO_DIMENSIONAL) {
        const twoDimensionalIds = [
          'directoryTree',
          'section',
          'axialSection',
          'roamingMode',
          'componentDetails',
        ];
        result = result.filter(
          (item: BtnProps) => !twoDimensionalIds.includes(item.id)
        );
      }
      const menus: BtnProps[][] = dataGroupingToDeepArray(result, 'grouping');
      setToolbarMenuList(menus);
    };
    const initBimWin = () => {
      if (pitWebglContainer) {
        createBimWin(pitWebglContainer.current, options, headers).then(res => {
          const { platform, type } = res;
          setBimwinData((pre: any) => {
            pre.bimType = type;
            pre.isLoading = false;
            pre.platform = platform;
            return { ...pre };
          });
          // 隐藏动画
          // 给场景添加背景颜色
          if (type === BIM_TYPE.THREE_DIMENSIONAL) {
            setBackgroundColor(
              platform,
              `linear-gradient(rgb(0, 191, 255), rgb(240, 255, 248))`
            );
          } else {
            setBackgroundColor(platform, `#28282a`);
            // 给多个视图设置颜色
            platform.Model.LayoutViewers.forEach((row: BIMWin2D) => {
              row.canvas.style.background = '#00000';
            });
          }
          setisModelLoading(true);
          onPropertyLoaded(platform, bimwinData.bimType);

          platform.bimwin.onModelLoaded.add(() => {
            requestAnimationFrame(platform);

            initToolbar();

            // 设置鼠标悬停状态
            outlineNodeSetEnable(platform, true);

            // 设置点选模式
            setSelectMode(platform, 'singlechoice');

            onPickPoint(platform, pitMenuRight.current);
          });
        });
      }
    };
    useEffect(() => {
      initBimWin();
    }, []);
    const fontArrNode = annotation.fontArr.map((item: any, index: number) => {
      return (
        <div key={index}>
          <PitToolTip context={item.name} placement="left">
            <div
              className={`pit-button pit-size ${
                annotation.fontCurrent === item.type ? 'pit-checked' : ''
              }`}
            >
              {item.name}
            </div>
          </PitToolTip>
        </div>
      );
    });
    const itemArrNode = annotation.itemArr.map((item: any, index: number) => {
      return (
        <div key={index}>
          <PitToolTip context={item.name}>
            <div
              className={`pit-button ${item.icon} ${
                item.type === annotation.itemCurrent ? 'pit-checked' : ''
              }`}
            ></div>
          </PitToolTip>
        </div>
      );
    });
    const colorArrNode = annotation.colorArr.map((item: any, index: number) => {
      return (
        <div key={index}>
          <PitToolTip context={item.name} placement="left">
            <div
              className={`pit-button ${styles['pit-color']} ${
                annotation.colorCurrent === item.type ? 'pit-checked' : ''
              }`}
            >
              <div
                className={styles['pit-color-button']}
                style={{ backgroundColor: item.color }}
              ></div>
            </div>
          </PitToolTip>
        </div>
      );
    });
    const lineArrNode = annotation.lineArr.map((item: any, index: number) => {
      return (
        <div key={index}>
          <PitToolTip context={item.name} placement="left">
            <div
              className={`pit-button pit-line ${
                annotation.lineCurrent === item.type ? 'pit-checked' : ''
              }`}
            >
              <div
                className="pit-line-button"
                style={{
                  height: item.height,
                  margin: item.margin,
                  background: annotation.colorArr[annotation.colorIndex].color,
                }}
              ></div>
            </div>
          </PitToolTip>
        </div>
      );
    });
    return (
      <div
        className="pit-bim-win-container"
        id="pitBimWinContainer"
        ref={pitBimWinContainer}
      >
        {/* <!-- 放置canvas容器 --> */}
        <div ref={pitWebglContainer} className="pit-webgl-container"></div>
        {/* <!-- 加载动画容器 --> */}
        {bimwinData.isLoading ? (
          <div className="pit-bim-win-loading" v-if="isLoading">
            <img src={loadingImg} alt="" />
          </div>
        ) : (
          ''
        )}
        <div
          className={`${styles['pit-bim-win-ui-container']} pit-bim-win-ui-container`}
        >
          <div className={styles['pit-ui']}>
            <div>
              <PitToolbarMenu
                style={{ display: isShowRootMenu ? '' : 'none' }}
                toolbarMenuList={toolbarMenuList}
                btnClickCallBack={btnClickCallBack}
              />

              {/* 漫游模式 */}
              {isShowFirstPersonMenu ? (
                <PitRoam platform={bimwinData.platform} close={roamClose} />
              ) : (
                ''
              )}

              {/* 批注 */}
              {annotation.isShowAnnotationMenu ? (
                <div
                  className="pit-toolbar pit-toolbar-bottom"
                  style={{ zIndex: 30 }}
                >
                  <div className="pit-toolbar-bottom-item">{itemArrNode}</div>

                  <div className="pit-toolbar-bottom-item">
                    {annotation.isLineAndFontSHow ? (
                      <div
                        className={`${styles['pit-combobox']} pit-font-button ${
                          annotation.fontBoxIsShow ? styles['pit-expand'] : ''
                        }`}
                      >
                        <div
                          className={`pit-sub-toolbar ${styles['pit-sub-toolbar']} pit-scroll-bar`}
                        >
                          {fontArrNode}
                        </div>
                        <div
                          className="pit-current"
                          onClick={() => annotationToggle('font')}
                        >
                          <PitToolTip context="字号">
                            <div className="pit-button pit-size">
                              {annotation.fontArr[annotation.fontIndex].name}
                            </div>
                          </PitToolTip>
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    <div
                      className={`${styles['pit-combobox']} ${
                        styles['pit-color']
                      } ${
                        annotation.colorBoxIsShow ? styles['pit-expand'] : ''
                      }`}
                    >
                      <div className="pit-toolbar-button"></div>
                      <div
                        className={`pit-sub-toolbar ${styles['pit-sub-toolbar']} pit-scroll-bar`}
                      >
                        {colorArrNode}
                      </div>
                      <div
                        className="pit-current"
                        onClick={() => annotationToggle('color')}
                      >
                        <PitToolTip
                          context="颜色"
                          show={!annotation.colorBoxIsShow}
                        >
                          <div className={`pit-button ${styles['pit-color']}`}>
                            <div
                              className={styles['pit-color-button']}
                              style={{
                                backgroundColor:
                                  annotation.colorArr[annotation.colorIndex]
                                    .color,
                              }}
                            ></div>
                          </div>
                        </PitToolTip>
                      </div>
                    </div>
                    {annotation.isLineAndFontSHow ? (
                      <div
                        className={`${styles['pit-combobox']} ${
                          annotation.lineBoxIsShow ? styles['pit-expand'] : ''
                        }`}
                      >
                        <div className="pit-toolbar-button"></div>
                        <div
                          className={`pit-sub-toolbar ${styles['pit-sub-toolbar']} pit-scroll-bar`}
                        >
                          {lineArrNode}
                        </div>
                        <div
                          className="pit-current"
                          onClick={() => annotationToggle('line')}
                        >
                          <PitToolTip
                            context="粗细"
                            show={!annotation.lineBoxIsShow}
                          >
                            <div className="pit-button pit-line">
                              <div
                                className="pit-line-button"
                                style={{
                                  height:
                                    annotation.lineArr[annotation.lineIndex]
                                      .height,
                                  margin:
                                    annotation.lineArr[annotation.lineIndex]
                                      .margin,
                                  background:
                                    annotation.colorArr[annotation.colorIndex]
                                      .color,
                                }}
                              ></div>
                            </div>
                          </PitToolTip>
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>

                  <div className="pit-toolbar-bottom-item">
                    <div className="pit-button pit-button-prisim">保存</div>
                    <div
                      className="pit-button pit-button-prisim"
                      onClick={annotationCancelBtn}
                    >
                      退出
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>
            {/* 目录树 */}
            <PitBimwinDialog
              title="目录树"
              visible={menuState.directoryTree}
              style={{
                left: '10px',
                top: '10px',
                width: '332px',
                height: '430px',
                minWidth: '332px',
                minHeight: '430px',
              }}
              beforeClose={beforeClose.bind(null, 'visible')}
            >
              <PitModuleTree></PitModuleTree>
            </PitBimwinDialog>
            {/* 测量 */}
            <PitBimwinDialog
              visible={menuState.measurement}
              title="测量"
              isResiz
              style={{
                zIndex: 99,
                right: '10px',
                top: '260px',
                width: '216px',
                height: '280px',
                minWidth: '216px',
                minHeight: '280px',
                marginBottom: '0px',
              }}
              beforeClose={beforeClose.bind(null, 'measureVisible')}
            >
              {menuState.measurement ? (
                <PitModuleMeasure platform={bimwinData.platform} />
              ) : (
                ''
              )}
            </PitBimwinDialog>
            {/* <!-- 剖切盒 --> */}
            <PitBimwinDialog
              isResiz={false}
              visible={menuState.section}
              title="剖切盒"
              style={{
                right: '100px',
                bottom: '100px',
                width: '200px',
                height: '226px',
              }}
              beforeClose={beforeClose.bind(null, 'pouQieVisible')}
            >
              <PitModuleSectioning />
            </PitBimwinDialog>
            {/* <!--  轴向剖切    --> */}
            <PitBimwinDialog
              isResiz={false}
              visible={menuState.axialSection}
              title="轴向剖切"
              style={{
                right: '100px',
                bottom: '100px',
                width: '200px',
                height: '156px',
              }}
              beforeClose={beforeClose.bind(null, 'rowPouQieVisible')}
            >
              <PitModuleSectionAxis />
            </PitBimwinDialog>
            {/* <!-- 构件详情 --> */}
            <PitBimwinDialog
              visible={menuState.componentDetails}
              title="构件属性"
              isResiz
              style={{
                right: '10px',
                top: '120px',
                width: '300px',
                height: '416px',
                minWidth: '300px',
                minHeight: '416px',
              }}
              beforeClose={beforeClose.bind(null, 'properties')}
            >
              <PitModuleProperties propertiesData={properties.value} />
            </PitBimwinDialog>
            {/* <!-- 标签列表 --> */}
            <PitBimwinDialog
              visible={menuState.label}
              isResiz
              title="标签列表"
              style={{
                right: '10px',
                top: '120px',
                width: '300px',
                height: '325px',
                minHeight: '325px',
                minWidth: '300px',
              }}
              beforeClose={beforeClose.bind(null, 'label')}
            >
              <PitModuleLabelBox />
            </PitBimwinDialog>
            {/* <!-- 设置 --> */}
            <PitBimwinDialog
              visible={menuState.setUp}
              isResiz={false}
              title="设置"
              style={{
                left: '540px',
                top: '300px',
                transform: 'none',
                width: '330px',
                height: 'auto',
              }}
              beforeClose={beforeClose.bind(null, 'setUp')}
            >
              <PitModuleSetUp />
            </PitBimwinDialog>
            {isModelLoading ? (
              <PitMenuRight
                ref={pitMenuRight}
                v-if="isModelLoading"
                platform={bimwinData.platform}
                properties={properties}
                open={wiGldBfPropertiesOpen}
              />
            ) : (
              ''
            )}
            {/* <!-- 基本信息 --> */}
            <PitBimwinDialog
              isResiz={false}
              visible={menuState.basicInformation}
              title="基本信息"
              style={{ left: '35%', top: '35%', width: '300px' }}
              beforeClose={beforeClose.bind(null, 'basicInformation')}
            >
              <PitModuleInformation />
            </PitBimwinDialog>
            {/* 插槽 */}
            {children}
          </div>
        </div>
      </div>
    );
  }
);
export default PitBimwinApp;
